import AboutHero from "../components/over-ons/AboutHero";
import AboutIntroSection from "../components/over-ons/AboutIntroSection";
import TestimonialsSection  from "../components/over-ons/TestimonialsSection";
const OverOns = () => (
  <>
    <AboutHero />
    <AboutIntroSection />
    <TestimonialsSection />
    {/* ...rest of your About content */}
  </>
);

export default OverOns;
